import { LOADING, SET_WEBSITE_LIST } from "../../Actions/Types";
import { editDomainNameAPI } from "../../Api/DomainApi/EditDomainApi";
import { getUserDetailsService } from "../UserAction/LoginActionService";
import { postUserActivityListService } from "../UserActivityService";
import { DomainDetailsService } from "./DomainDetails";

// service to get domain list only
const EditDomainService = async (
    token: string, // access token
    websiteId: number,
    domain: string,
    dispatch: Function, // dispatch function to store redux data
    unchangedDomainName:string,
): Promise<any> => {

    // Set Loading
    dispatch({
        type: LOADING,
        payload: true,
    });

    // API to get domain list
    
    editDomainNameAPI(token, websiteId, domain).then((listRes) => {
        console.log('listRes: ', listRes);
        // check if response is ok
        if (listRes) {

            getUserDetailsService(token, dispatch).then(async (userRes) => {
                // check if response is ok
                if (userRes.status === 200) {

                    // service to get domain details
                    DomainDetailsService(token, websiteId, dispatch).then(async (res) => {
                        // check if response is ok
                        if (res.status === 200) {

                            dispatch({
                                type: LOADING,
                                payload: false,
                            });

                        }
                    });

                }
            });

            postUserActivityListService(token, 'Domain Updated', `${unchangedDomainName}: Updated successfully`)

        } else {

            // remove Loading
            dispatch({
                type: LOADING,
                payload: false,
            });
        }
    });

    return {status:200}

}

export { EditDomainService }